
module.exports = require('./dist/checkout.lib');
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/paypal-checkout/index.js
// module id = 524
// module chunks = 0